"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTEXTS = exports.DEFAULT_USER_PERMISSIONS = exports.COMMENTS = void 0;
var access_type_name_enum_1 = require("./enums/access-type-name.enum");
var access_type_enum_1 = require("./enums/access-type.enum");
var access_type_scope_permissions_enum_1 = require("./enums/permissions/access-type-scope-permissions.enum");
var material_results_scope_permissions_enum_1 = require("./enums/permissions/material-results-scope-permissions.enum");
var material_scope_permissions_enum_1 = require("./enums/permissions/material-scope-permissions.enum");
var material_settings_scope_permissions_enum_1 = require("./enums/permissions/material-settings-scope-permissions.enum");
var media_scope_permissions_enum_1 = require("./enums/permissions/media-scope-permissions.enum");
var organization_scope_permissions_enum_1 = require("./enums/permissions/organization-scope-permissions.enum");
var permissions_scope_enum_1 = require("./enums/permissions/permissions-scope.enum");
var publish_scope_permissions_enum_1 = require("./enums/permissions/publish-scope-permissions.enum");
var review_scope_permissions_enum_1 = require("./enums/permissions/review-scope-permissions.enum");
exports.COMMENTS = {
    context: {
        types: {
            course: 'course',
            section: 'section',
            question: 'question',
            informationContent: 'informationContent',
            introduction: 'introduction',
            afterword: 'afterword'
        },
        properties: {
            title: 'title',
            introduction: 'introduction',
            instruction: 'instruction',
            voiceOver: 'voiceOver',
            response: 'response',
            learningContent: 'learningContent',
            passedAfterword: 'passedAfterword',
            failedAfterword: 'failedAfterword',
            afterword: 'afterword',
            hint: 'hint',
            answers: 'answers',
            explanation: 'explanation'
        },
        questionTypes: {
            singleSelectText: 'singleSelectText',
            multipleSelect: 'multipleSelect',
            fillInTheBlank: 'fillInTheBlank',
            dragAndDropText: 'dragAndDropText',
            informationContent: 'informationContent',
            singleSelectImage: 'singleSelectImage',
            textMatching: 'textMatching',
            hotspot: 'hotspot',
            statement: 'statement',
            openQuestion: 'openQuestion',
            rankingText: 'rankingText'
        },
        localizeKeys: {
            titleOfTheCourse: 'titleOfTheCourse',
            courseIntroductionTitle: 'courseIntroductionTitle',
            afterword: 'afterword',
            section: 'section',
            contentItem: 'contentItem',
            singleChoiceQuestion: 'singleChoiceQuestion',
            singleSelectImage: 'singleSelectImage',
            multipleChoiceQuestion: 'multiChoiceQuestion',
            fillInTheBlankQuestion: 'fillInTheBlankQuestion',
            textMatchingQuestion: 'textMatchingQuestion',
            dragNDropQuestion: 'dragNDropQuestion',
            statementQuestion: 'statementQuestion',
            hotSpotQuestion: 'hotspotQuestion',
            openQuestion: 'openQuestion',
            rankingTextQuestion: 'rankingTextQuestion',
            afterwordPassed: 'positiveLearnerScore',
            afterwordFailed: 'negativeLearnerScore',
            questionTitle: 'questionTitle',
            contentTitleLabel: 'contentTitleLabel',
            questionTitleLabel: 'questionTitleLabel',
            contentArea: 'contentArea',
            answerOptions: 'answerOptions',
            questionFeedback: 'questionFeedback',
            questionHint: 'hint',
            explanationForAnswerOptions: 'explanationForAnswerOptions',
            questionInstruction: 'questionContent',
            voiceOver: 'voiceOver',
            onTheAfterwordPassed: 'onThePositiveLearnerScore',
            onTheAfterwordFailed: 'onTheNegativeLearnerScore',
            questionExplanationInTheQuestion: 'onTheExplanationForAnswerOptionsInTheQuestion',
            voiceOverInTheQuestion: 'onTheVoiceOverInTheQuestion',
            voiceOverInTheContent: 'onTheVoiceOverInTheContentItem',
            questionInstructionInTheQuestion: 'onTheInstructionInTheQuestion',
            questionHintInTheQuestion: 'onTheHintInTheQuestion',
            answerOptionsInTheQuestion: 'onTheAnswerOptionsInTheQuestion',
            questionResponseInTheQuestion: 'onTheResponseInTheQuestion',
            hintInTheQuestion: 'onTheHintInTheQuestion',
            contentTitleInTheQuestion: 'onTheTitleOfTheContentItem',
            questionTitleInTheQuestion: 'onTheTitleOfTheQuestion',
            onTheTitleOfTheCourse: 'onTheTitleOfTheCourse',
            onTheIntroductionOfTheCourse: 'onTheIntroductionOfTheCourse',
            onTheAfterwordOfTheCourse: 'onTheAfterwordOfTheCourse',
            onTheTitleOfTheSection: 'onTheTitleOfTheSection',
            onTheQuestion: 'onTheQuestion',
            onTheContentArea: 'onTheContentArea',
            onTheContentAreaInTheIntroduction: 'onTheContentAreaInTheIntroduction',
            onTheContentItem: 'onTheContentItem'
        }
    }
};
exports.DEFAULT_USER_PERMISSIONS = (_a = {},
    _a[permissions_scope_enum_1.PermissionsScopeEnum.organization] = (_b = {},
        _b[organization_scope_permissions_enum_1.OrganizationScopePermissions.managing] = false,
        _b[organization_scope_permissions_enum_1.OrganizationScopePermissions.groupManaging] = false,
        _b[organization_scope_permissions_enum_1.OrganizationScopePermissions.groupFiltering] = false,
        _b),
    _a[permissions_scope_enum_1.PermissionsScopeEnum.accessType] = (_c = {},
        _c[access_type_scope_permissions_enum_1.AccessTypeScopePermissions.name] = access_type_name_enum_1.AccessTypeName[access_type_enum_1.AccessType.free],
        _c[access_type_scope_permissions_enum_1.AccessTypeScopePermissions.canUpgradeSubscription] = true,
        _c),
    _a[permissions_scope_enum_1.PermissionsScopeEnum.material] = (_d = {},
        _d[material_scope_permissions_enum_1.MaterialScopePermissions.filtering] = false,
        _d[material_scope_permissions_enum_1.MaterialScopePermissions.sharedMaterialsView] = false,
        _d[material_scope_permissions_enum_1.MaterialScopePermissions.materialTransferring] = false,
        _d[material_scope_permissions_enum_1.MaterialScopePermissions.groupsInfoView] = false,
        _d[material_scope_permissions_enum_1.MaterialScopePermissions.materialsLimit] = 3,
        _d[material_scope_permissions_enum_1.MaterialScopePermissions.tagsManaging] = false,
        _d),
    _a[permissions_scope_enum_1.PermissionsScopeEnum.materialSettings] = (_e = {},
        _e[material_settings_scope_permissions_enum_1.MaterialSettingsScopePermissions.certificates] = false,
        _e[material_settings_scope_permissions_enum_1.MaterialSettingsScopePermissions.xliff] = false,
        _e),
    _a[permissions_scope_enum_1.PermissionsScopeEnum.media] = (_f = {},
        _f[media_scope_permissions_enum_1.MediaScopePermissions.storageSpace] = 262144000,
        _f),
    _a[permissions_scope_enum_1.PermissionsScopeEnum.review] = (_g = {},
        _g[review_scope_permissions_enum_1.ReviewScopePermissions.commentsManaging] = false,
        _g),
    _a[permissions_scope_enum_1.PermissionsScopeEnum.materialResults] = (_h = {},
        _h[material_results_scope_permissions_enum_1.MaterialResultsScopePermissions.downloadResults] = false,
        _h[material_results_scope_permissions_enum_1.MaterialResultsScopePermissions.viewDetailedResults] = false,
        _h[material_results_scope_permissions_enum_1.MaterialResultsScopePermissions.loadMoreResults] = false,
        _h[material_results_scope_permissions_enum_1.MaterialResultsScopePermissions.resultsSharing] = false,
        _h[material_results_scope_permissions_enum_1.MaterialResultsScopePermissions.viewResultsAnalytics] = false,
        _h[material_results_scope_permissions_enum_1.MaterialResultsScopePermissions.learnerResultsReportGeneration] = false,
        _h),
    _a[permissions_scope_enum_1.PermissionsScopeEnum.publish] = (_j = {},
        _j[publish_scope_permissions_enum_1.PublishScopePermissions.scorm] = false,
        _j),
    _a);
exports.CONTEXTS = [
    {
        /**
         * description: 'context for course title'
         */
        type: exports.COMMENTS.context.types.course,
        property: exports.COMMENTS.context.properties.title,
        key: exports.COMMENTS.context.localizeKeys.titleOfTheCourse,
        description: exports.COMMENTS.context.localizeKeys.onTheTitleOfTheCourse
    },
    {
        /**
         * description: 'context for course introduction'
         */
        type: exports.COMMENTS.context.types.course,
        property: exports.COMMENTS.context.properties.introduction,
        key: exports.COMMENTS.context.localizeKeys.courseIntroductionTitle,
        description: exports.COMMENTS.context.localizeKeys.onTheIntroductionOfTheCourse
    },
    {
        /**
         * description: 'context for course afterword',
         */
        type: exports.COMMENTS.context.types.course,
        property: exports.COMMENTS.context.properties.afterword,
        key: exports.COMMENTS.context.localizeKeys.afterword,
        description: exports.COMMENTS.context.localizeKeys.onTheAfterwordOfTheCourse
    },
    {
        /**
         description: 'context for section title',
        */
        type: exports.COMMENTS.context.types.section,
        property: exports.COMMENTS.context.properties.title,
        key: exports.COMMENTS.context.localizeKeys.section,
        description: exports.COMMENTS.context.localizeKeys.onTheTitleOfTheSection
    },
    {
        /**
         description: 'context for information content title',
        */
        type: exports.COMMENTS.context.types.informationContent,
        property: exports.COMMENTS.context.properties.title,
        key: exports.COMMENTS.context.localizeKeys.contentTitleLabel,
        description: exports.COMMENTS.context.localizeKeys.contentTitleInTheQuestion
    },
    {
        /**
         * description: 'context for question without type (legacy)',
         */
        type: exports.COMMENTS.context.types.question,
        property: undefined,
        questionType: undefined,
        key: exports.COMMENTS.context.localizeKeys.questionTitle,
        description: exports.COMMENTS.context.localizeKeys.questionTitleInTheQuestion
    },
    {
        /**
         * description: 'context for informationContent title',
         */
        type: exports.COMMENTS.context.types.informationContent,
        property: undefined,
        key: exports.COMMENTS.context.localizeKeys.contentItem,
        description: exports.COMMENTS.context.localizeKeys.onTheContentItem
    },
    {
        /**
         description: 'context for single choice question',
        */
        type: exports.COMMENTS.context.types.question,
        questionType: exports.COMMENTS.context.questionTypes.singleSelectText,
        key: exports.COMMENTS.context.localizeKeys.singleChoiceQuestion,
        description: exports.COMMENTS.context.localizeKeys.onTheQuestion
    },
    {
        /**
         * description: 'context for single select image question',
         */
        type: exports.COMMENTS.context.types.question,
        questionType: exports.COMMENTS.context.questionTypes.singleSelectImage,
        key: exports.COMMENTS.context.localizeKeys.singleSelectImage,
        description: exports.COMMENTS.context.localizeKeys.onTheQuestion
    },
    {
        /**
         * description: 'context for multiple choice question',
         */
        type: exports.COMMENTS.context.types.question,
        questionType: exports.COMMENTS.context.questionTypes.multipleSelect,
        key: exports.COMMENTS.context.localizeKeys.multipleChoiceQuestion,
        description: exports.COMMENTS.context.localizeKeys.onTheQuestion
    },
    {
        /**
         * description: 'context for fill in the blank question',
         */
        type: exports.COMMENTS.context.types.question,
        questionType: exports.COMMENTS.context.questionTypes.fillInTheBlank,
        key: exports.COMMENTS.context.localizeKeys.fillInTheBlankQuestion,
        description: exports.COMMENTS.context.localizeKeys.onTheQuestion
    },
    {
        /**
         * description: 'context for text matching question',
         * */
        type: exports.COMMENTS.context.types.question,
        questionType: exports.COMMENTS.context.questionTypes.textMatching,
        key: exports.COMMENTS.context.localizeKeys.textMatchingQuestion,
        description: exports.COMMENTS.context.localizeKeys.onTheQuestion
    },
    {
        /**
         * description: 'context for drag and drop question',
         * */
        type: exports.COMMENTS.context.types.question,
        questionType: exports.COMMENTS.context.questionTypes.dragAndDropText,
        key: exports.COMMENTS.context.localizeKeys.dragNDropQuestion,
        description: exports.COMMENTS.context.localizeKeys.onTheQuestion
    },
    {
        /**
         * description: 'context for statement question',
         * */
        type: exports.COMMENTS.context.types.question,
        questionType: exports.COMMENTS.context.questionTypes.statement,
        key: exports.COMMENTS.context.localizeKeys.statementQuestion,
        description: exports.COMMENTS.context.localizeKeys.onTheQuestion
    },
    {
        /**
         * description: 'context for hotspot question',
         */
        type: exports.COMMENTS.context.types.question,
        questionType: exports.COMMENTS.context.questionTypes.hotspot,
        key: exports.COMMENTS.context.localizeKeys.hotSpotQuestion,
        description: exports.COMMENTS.context.localizeKeys.onTheQuestion
    },
    {
        /**
         * description: 'context for open question',
         *  */
        type: exports.COMMENTS.context.types.question,
        questionType: exports.COMMENTS.context.questionTypes.openQuestion,
        key: exports.COMMENTS.context.localizeKeys.openQuestion,
        description: exports.COMMENTS.context.localizeKeys.onTheQuestion
    },
    {
        /**
         * description: 'context for ranking text question',
         */
        type: exports.COMMENTS.context.types.question,
        questionType: exports.COMMENTS.context.questionTypes.rankingText,
        key: exports.COMMENTS.context.localizeKeys.rankingTextQuestion,
        description: exports.COMMENTS.context.localizeKeys.onTheQuestion
    },
    {
        /**
         * description: 'context title for question title',
         * */
        type: exports.COMMENTS.context.types.question,
        property: exports.COMMENTS.context.properties.title,
        key: exports.COMMENTS.context.localizeKeys.questionTitleLabel,
        description: exports.COMMENTS.context.localizeKeys.questionTitleInTheQuestion
    },
    {
        /**
         * description: 'context title for question response'
         */
        type: exports.COMMENTS.context.types.question,
        property: exports.COMMENTS.context.properties.response,
        key: exports.COMMENTS.context.localizeKeys.questionFeedback,
        description: exports.COMMENTS.context.localizeKeys.questionResponseInTheQuestion
    },
    {
        /**
         * description: 'context title for question answer options'
         */
        type: exports.COMMENTS.context.types.question,
        property: exports.COMMENTS.context.properties.answers,
        key: exports.COMMENTS.context.localizeKeys.answerOptions,
        description: exports.COMMENTS.context.localizeKeys.answerOptionsInTheQuestion
    },
    {
        /**
         * description: 'context title for question hint'
         *  */
        type: exports.COMMENTS.context.types.question,
        property: exports.COMMENTS.context.properties.learningContent,
        key: exports.COMMENTS.context.localizeKeys.questionHint,
        description: exports.COMMENTS.context.localizeKeys.questionHintInTheQuestion
    },
    {
        /**
         * description: 'context title for question explanation'
         */
        type: exports.COMMENTS.context.types.question,
        property: exports.COMMENTS.context.properties.explanation,
        key: exports.COMMENTS.context.localizeKeys.explanationForAnswerOptions,
        description: exports.COMMENTS.context.localizeKeys.questionExplanationInTheQuestion
    },
    {
        /**
         * description: 'context title for question instruction'
         */
        type: exports.COMMENTS.context.types.question,
        property: exports.COMMENTS.context.properties.instruction,
        key: exports.COMMENTS.context.localizeKeys.questionInstruction,
        description: exports.COMMENTS.context.localizeKeys.questionInstructionInTheQuestion
    },
    {
        /**
         * description: 'context title for question voiceover'
         * */
        type: exports.COMMENTS.context.types.question,
        property: exports.COMMENTS.context.properties.voiceOver,
        key: exports.COMMENTS.context.localizeKeys.voiceOver,
        description: exports.COMMENTS.context.localizeKeys.voiceOverInTheQuestion
    },
    {
        /**
         * description: 'context title for information content voiceover'
         */
        type: exports.COMMENTS.context.types.informationContent,
        property: exports.COMMENTS.context.properties.voiceOver,
        key: exports.COMMENTS.context.localizeKeys.voiceOver,
        description: exports.COMMENTS.context.localizeKeys.voiceOverInTheContent
    },
    {
        /**
         * description: 'context for information content content',
         */
        type: exports.COMMENTS.context.types.informationContent,
        property: exports.COMMENTS.context.properties.learningContent,
        key: exports.COMMENTS.context.localizeKeys.contentArea,
        description: exports.COMMENTS.context.localizeKeys.onTheContentArea
    },
    {
        /**
         * description: 'context for course intro content'
         */
        type: exports.COMMENTS.context.types.introduction,
        property: exports.COMMENTS.context.properties.learningContent,
        key: exports.COMMENTS.context.localizeKeys.contentArea,
        description: exports.COMMENTS.context.localizeKeys.onTheContentAreaInTheIntroduction
    },
    {
        /**
         * description: 'context for afterword passed',
         */
        type: exports.COMMENTS.context.types.afterword,
        property: exports.COMMENTS.context.properties.passedAfterword,
        key: exports.COMMENTS.context.localizeKeys.afterwordPassed,
        description: exports.COMMENTS.context.localizeKeys.onTheAfterwordPassed
    },
    {
        /**
         * description: 'context for afterword failed',
         */
        type: exports.COMMENTS.context.types.afterword,
        property: exports.COMMENTS.context.properties.failedAfterword,
        key: exports.COMMENTS.context.localizeKeys.afterwordFailed,
        description: exports.COMMENTS.context.localizeKeys.onTheAfterwordFailed
    }
];
